import type { TransactionRow } from '@/api/hooks/useTransactions';
import type { LinkCandidate } from '@/api/hooks/useLinkCandidates';
import { decimalIsZero, decimalSubtract, decimalSum } from './decimal';

export function matchesCategoryFilter(row: TransactionRow, filter: string): boolean {
  if (filter === 'uncategorized') {
    return row.line_items.length === 0 || row.line_items.some((item) => item.category_slug === null);
  }
  if (filter === 'unallocated') {
    if (row.line_items.length === 0) return false;
    const allocated = decimalSum(row.line_items.map((item) => item.amount));
    return !decimalIsZero(decimalSubtract(row.amount, allocated));
  }
  return row.line_items.some((item) => item.category_slug === filter);
}

export function matchesMerchantFilter(row: TransactionRow, filter: string): boolean {
  if (filter.startsWith('raw:')) return row.merchant_raw === filter.slice(4);
  return row.merchant?.merchant_id === filter;
}

export interface TransactionScope {
  accountId?: string | null;
  dateFrom?: string;
  dateTo?: string;
}

export function candidateInTransactionScope(candidate: LinkCandidate, scope: TransactionScope): boolean {
  return candidate.legs.some((leg) => {
    if (Number(leg.amount) >= 0) return false;
    if (scope.accountId && leg.account.account_id !== scope.accountId) return false;
    const postedDate = leg.posted_at.slice(0, 10);
    if (scope.dateFrom && postedDate < scope.dateFrom.slice(0, 10)) return false;
    if (scope.dateTo && postedDate > scope.dateTo.slice(0, 10)) return false;
    return true;
  });
}
